export default [
  {
    name: 'journeys',
    path: '/journeys',
    component: () => import(/* webpackChunkName: "journeys" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Jornadas',
      icon: 'dvr',
      label: 'Jornadas',
      roles: ['Admin']
    }
  },
  {
    name: 'journey-ai',
    path: '/journeys-ai',
    component: () => import(/* webpackChunkName: "journey-ai" */ './AIComposer.vue'),
    meta: {
      showNavbar: false,
      title: 'Jornada - Criar com IA',
      icon: 'dvr',
      label: 'Criar com IA',
      roles: ['Admin']
    }
  },
  {
    name: 'journey-builder',
    path: '/journeys/:id',
    component: () => import(/* webpackChunkName: "journey-builder" */ './Builder.vue'),
    meta: {
      showNavbar: false,
      title: 'Jornada - Editor',
      icon: 'dvr',
      label: 'Jornada - Editor',
      roles: ['Admin']
    }
  }
]
